import i18n from '../../../i18n/i18n'

class ErrorHandler {

  constructor() {
    this.initHandler();
  }

  initHandler() {

    this.savingError = (vm, error) => {
      if (error.response && error.response.status === 400) {
        vm.$vs.notify({
          color: "danger",
          title: i18n.t("SavingError"),
          text: error.response.data.title === undefined ? error.response.data.message : error.response.data.title
        });
      } else if (error.response && error.response.status === 409) {
        vm.$vs.notify({
          color: "danger",
          title: i18n.t("ConcurrencyError"),
          text: i18n.t("ConcurrencyMessage")
        });
      }
      else {
        vm.$vs.notify({
          color: "danger",
          title: i18n.t("SavingError"),
          text: error.message
        });
      }
    }

    this.loadingError = (vm, error) => {
      vm.$vs.notify({
        color: "danger",
        title: i18n.t("LoadingError"),
        text: error.message
      });
    }

    this.deletingError = (vm, error) => {
      if (error.response.status === 409) {
        vm.$vs.notify({
          color: "danger",
          title: i18n.t("ConcurrencyError"),
          text: i18n.t("ConcurrencyMessage")
        });
      }
      else {
        vm.$vs.notify({
          color: "danger",
          title: i18n.t("DeletingError"),
          text: error.message
        });
      }
    }

    this.cqrsError = (vm, error) => {
      console.error(error);
      const options = this.getLocalizedOptions(error.response.status);
      if (error.response !== undefined && error.response.data.errors) {
        const propNames = Object.getOwnPropertyNames(error.response.data.errors);
        let messages = "";
        propNames.forEach(function(element) {
          messages = messages + String(error.response.data.errors[element]) + '</br></br>';
        });
        vm.$vs.notify({
          color: options.color,
          title: options.title,
          text: messages
        });
      }
      else if (error.response !== undefined && (error.response.data.exceptionDetails)) {
        const messages = error.response.data.exceptionDetails.join('</br></br>');
       
        vm.$vs.notify({
          color: options.color,
          title: options.title,
          text: messages
        });
      }
      else if (error.response !== undefined && error.response.data.messages) {
        const messages = error.response.data.messages.map(m => m.key).join('</br></br>');
        
        vm.$vs.notify({
          color: options.color,
          title: options.title,
          text: messages
        });
      }
      else {
        vm.$vs.notify({
          color: options.color,
          title: options.title,
          text: error.message
        });  
      }      
    }

    this.getLocalizedOptions = (statusCode) => {
      if (statusCode === 500) {
        return {
          color: "danger",
          title: i18n.t("SavingError")
        };
      }
      else if (statusCode === 409) {          
        return {
          color: "danger",
          title: i18n.t("ConcurrencyError")
        };
      }
      else if (statusCode === 400) {          
        return {
          color: "warning",
          title: i18n.t("ValidationError")
        };
      }
      else {          
        return {
          color: "danger",
          title: i18n.t("Error")
        };
      }
    }
  }
}

const errorHandler = new ErrorHandler();

export { errorHandler };
